module.exports = __webpack_public_path__ + "media/src/images/app_icons/ios_splashscreens/iphonex_splash-68b5e0fbc6aedc2eb408c68e162e478d.png";